import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Document: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[1.5px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 7.00024V17.0002C21 20.0002 19.5 22.0002 16 22.0002H8C4.5 22.0002 3 20.0002 3 17.0002V7.00024C3 4.00024 4.5 2.00024 8 2.00024H16C19.5 2.00024 21 4.00024 21 7.00024Z"
      stroke="currentColor"
      strokeWidth="currentStrokeWidth"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 4.50024V6.50024C14.5 7.60024 15.4 8.50024 16.5 8.50024H18.5M8 13.0002H12M8 17.0002H16"
      stroke="currentColor"
      strokeWidth="currentStrokeWidth"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Document;
